import React, { FC } from 'react'
import { Box, Text, Flex, Button } from '@chakra-ui/react'
import { finishScenario, selectAnswers, useDispatch, useSelector } from '../../state'
import { Answers } from '../../state/interfaces'
import { useTranslation } from 'react-i18next'

export const InternetUsageInfoOnly: FC = () => {
  const { t } = useTranslation()
  const answers: Answers = useSelector(selectAnswers)
  const dispatch = useDispatch()

  const onSubmit = () => {
    dispatch(finishScenario())
  }

  return (
    <Flex alignItems={'center'} direction={'column'}>
      <Box maxWidth={370} padding={3}>
        <Text
          fontSize="xxs"
          fontWeight="bold"
          color="green.500"
          textTransform="uppercase"
          marginBottom={2}
          textAlign="center"
        >
          {t('common_complete')}
        </Text>
        <Text fontSize="sm" marginBottom={2} textAlign="center">
          {answers && answers['internetSpeed-or-help'] && answers['internetSpeed-or-help']![0] === 'speed-search'
            ? t('common_your-selected-internet-speed')
            : t('common_we-estimate-your-internet-speed')}
        </Text>
        <Text fontSize="5xl" fontWeight="bold" lineHeight={15} marginBottom={2} textAlign="center">
          {answers['internet-speed'] && answers['internet-speed']![0] !== 'custom-speed'
            ? answers['internet-speed']
            : answers['download-speed'] ?? 0}{' '}
          {t('common_mbps')}
        </Text>
      </Box>
      <Box>
        <Button
          onClick={() => onSubmit()}
          borderRadius={'xl'}
          textColor="white"
          fontSize={22}
          bg="#f05153"
          size={'lg'}
          mt={3}
        >
          {t('see-your-plan')}
        </Button>
      </Box>
    </Flex>
  )
}
